// ##############################
let _treeData = {};
let _treeHistory = { index: -1, history: [] };
let _addNodeModal = null;
let _saveTreeTimer = null;
let _savingFlg = false;
let _treeElement = null;
let _nodeListObservers = [];
const _maxHistory = 10;

/**
 * ツリーを生成する関数
 *
 * 下記の順で処理を行う
 * 1. 最初の質問になるセクションを取得し作成
 * 2. セクションを親に持つノードを取得し、localIndex順にソートして作成
 * 3. ノードがnextSectionIdを持つなら、セクションを子要素として作成
 * 4. 以降、リレーションされているノードとセクションが再帰的に生成される
 * 5. 全て生成し終わったら、イベントを設定して完了
 *
 * @param {JSON} treeData ツリー情報
 * @param {Boolean} whenHistory 履歴からの更新呼び出しかどうか
 * @return {void}
 */
function createTree(treeData, whenHistory = false) {
	_treeData = treeData;
	let firstSection = treeData.firstSection;
	let nodes = treeData.nodes;
	let sections = treeData.sections;

	// DOMリセット
	$('#' + treeData.canvasElementId).empty();

	createSection(firstSection, treeData.canvasElementId, true);

	// Event Set
	setAddNodeButtonEvent();
	setNodeEvent();
	setSectionEvent();
	checkLinkButtonEvent();
	setSortable($('.sortable'));
	updateCanvasHeight();

	if ( $('#tree-undo') && $('#tree-redo') ) {
		$('#tree-undo').off().on('click', function () {
			undoTree();
		});
		$('#tree-redo').off().on('click', function () {
			redoTree();
		});
	}

	createAddNodeModal();
	// 初回生成時に、読み込み内容をヒストリーに追加しておく
	if (whenHistory == false) {
		addHistory();
	}

	_treeElement = $('#' + _treeData.canvasElementId);
}

/**
 * 質問項目として、セクションを生成する関数
 * @param {JSON} nodeData ノード情報
 * @param {String} parentElementId 親要素のID
 * @param {Boolean} isFirst 最初の質問かどうか
 */
function createSection(nodeData, parentElementId, isFirst = false) {
	let contentType = nodeData.contentType;
	let content = "";
	let classList = "";
	let sectionLabel = "回答";

	// ツリーの開始地点なら、firstクラスを付与する
	if (isFirst) {
		classList = "section first";
		sectionLabel = "質問";
	} else {
		classList = "section";
	}

	// contentTypeが未定義なら、textを設定する
	if (contentType === undefined || contentType === null) {
		contentType = "text";
	}

	// contentTypeに応じて、contentの内容を変更する
	if (contentType === "text") {
		content = `<div class="section-label question bg-cx_base-800">${sectionLabel}</div>` +
							`<div class="content"><textarea class="form-control" rows="3">${nodeData.content}</textarea></div>
							<div class="node-list sortable">
								<div class="node-anchor command-button">
									<div class="add-node bg-cx_jump-800">+選択肢を追加</div>
								</div>
							</div>
							<div class="nodes"></div>`;

	} else if (contentType === "link") {
			content = `<div class="section-label link">リンク</div>` +
								`<div class="content"><textarea class="form-control" rows="3">${nodeData.content}</textarea></div>` +
								`<div class="check-link">確認</div>`;
	}

	// DOMを生成
	let section = $(
			`<div id="section-${nodeData.id}" class="${classList}" data-content-type="${contentType}">` +
				content +
			`</div>`
	);

	if (parentElementId != _treeData.canvasElementId) {
		parentElementId = `node-${parentElementId}`;
	}

	$(`#${parentElementId}`).append(section);
	// 生成されたSectionを親（parentId）として設定しているNodeが存在するなら、
	// localIndex順にソートして、子ノードとして生成する
	let childNodes = _treeData.nodes.filter(node => node.parentId == nodeData.id);
	if (childNodes.length > 0) {
		childNodes.sort((a, b) => a.localIndex - b.localIndex);
		childNodes.forEach(function (node, i) {
			createNode(node, nodeData.id);
			if (i == childNodes.length - 1) {
				updateNodeListHeight(section.children('.node-list'));
			}
		});
	}
}



/**
 * 子ノードを生成する関数
 *
 * 生成したnodeにnextSectionIdが存在する場合、追加で子要素としてセクションを生成する
 *
 * @param {JSON} nodeData ノード情報
 * @param {String} parentElementId ノードを格納する親要素のID
 */
function createNode(nodeData, parentElementId) {
	let parentElement = $(`#section-${parentElementId}`);

	// 子を生成するタイミングで、親セクションにstickyクラスを付与する
	parentElement.addClass('sticky');

	let node = $(
			`<div id="node-${nodeData.id}" class="node">` +
				`<div class= "node-label input-group input-group-sm">` +
					`<input type="text" class="form-control" value="${nodeData.content}">` +
				`</div>` +
			`</div>`
	);
	// section内nodesの最後に追加する
	parentElement.find('.nodes').first().append(node);

	// 目次の作成
	if (parentElement.children('>.content+.node-list').length == 0) {
			parentElement.children('>.content').after(
					`<div class="node-list sortable">
							<div class="node-anchor command-button">
									<div class="add-node bg-cx_jump-800">+選択肢を追加</div>
							</div>
					</div>`
			);
	}
	// 目次にノードのアンカーを追加
	let nodeAnchor = $(`<div class="node-anchor sortable-element">
												<span class= "sortable-handle">::</span>
												<a href="#node-${nodeData.id}">${nodeData.content}</a>
											</div>`);
	//.command-buttonの前に追加
	parentElement.find('>.node-list>.command-button').before(nodeAnchor);
	nodeAnchor.children('a').off().on('click', function (event) {
		// ターゲット位置までスクロール
		event.preventDefault();
		let targetNode = $(this).attr('href');
		scrollToTarget($(targetNode));
	});


	// nextSectionIdが存在するなら、ノードの子要素としてセクションを生成する
	// セクションのcontentはNodeのanswer
	if (nodeData.nextSectionId) {
		let sectionNodeData = _treeData.sections.find(section => section.id == nodeData.nextSectionId);
		// TODO: 子セクションのタイプを事前に取得. beforeの色設定などに利用したい。
		node.attr('data-next-section-type', sectionNodeData.contentType);
		// セクション生成に再帰
		createSection(sectionNodeData, nodeData.id);
	}
}

/**
 * ノード追加用のモーダル要素を作成し、bodyに追加する関数
 *
 * 下記メソッドにてモーダル操作を行う
 * - modalShow() ... モーダルを表示する
 * - modalHide() ... モーダルを非表示にする
 */
function createAddNodeModal() {
	// 作成済みなら何もしない
	if (_addNodeModal !== null) {return;}

	let modal = $(
			`<div class="modal-background">
				<div class="modal-wrapper">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title">選択肢の追加</h5>
							<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
						</div>
						<div class="modal-body">
							<div class="mb-3">
								<label for="addNodeContent" class="form-label">選択肢のテキスト</label>
								<input type="text" class="form-control" id="addNodeContent">
							</div>
							<div class="form-check">
								<input class="form-check-input" type="radio" name="selectSectionType" id="selectSectionQuestion" value="text" checked>
									<label class="form-check-label" for="selectSectionQuestion">
										回答を追加
									</label>
							</div>
							<div class="form-check">
								<input class="form-check-input" type="radio" name="selectSectionType" id="selectSectionLink" value="link">
									<label class="form-check-label" for="selectSectionLink">
										リンク先を追加
									</label>
							</div>
							<textarea id="addSectionContent" class="form-control" rows="3"></textarea>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-secondary modal-close" data-bs-dismiss="modal">キャンセル</button>
							<button id="addNodeFromModal" type="button" class="btn btn-primary bg-cx_base-800">この内容で追加</button>
						</div>
					</div>
				</div>
			</div>`
			);
	$(document.body).append(modal);
	_addNodeModal = modal;
	$('.modal-close').on('click', function (ev) {
		if (ev.eventPhase == 2) {
			modalHide();
		}
	});
}

/**
 * モーダルを表示する関数
 */
function modalShow() {
	_addNodeModal.addClass('show');
}
/**
 * モーダルを非表示にする関数
 */
function modalHide() {
	_addNodeModal.removeClass('show');
}


/**
 * ツリー情報の更新と保存
 *
 * ツリー情報を更新し、3秒後に自動保存する。
 * 保存までの3秒間に再度更新された場合は、保存までの待機時間をリセットする。
 *
 * @param {Boolean} whenHistory 履歴からの更新呼び出しかどうか
 * @return {JSON} ツリー情報JSON
 */
function updateTreeData(whenHistory = false) {
	console.log('updateTreeData');

	// 最初の質問セクションを取得
	let firstSection = getSectionData($("#section-0").first());

	// 一般Nodesの更新
	let newNodes = [];
	$('.node').each(function (i, element) {
		newNodes.push(getNodeData($(element)));
	});

	let newSections = [];
	$('.section').each(function (i, element) {
		newSections.push(getSectionData($(element)));
	});

	// ツリー情報の更新
	_treeData.firstSection = firstSection;
	_treeData.nodes = newNodes;
	_treeData.sections = newSections;

	// 更新が行われた際に自動保存。保存処理中かどうかを判定するために、タイマーで非同期処理を行う。
	clearTimeout(_saveTreeTimer);
	savingFlg(true);
	_saveTreeTimer = setTimeout(function () {
		console.log('save');
		_saveTreeTimer = null;
		saveTreeData(whenHistory);
		_treeElement.trigger('onSaveCompleted');
	}, 50);

	return _treeData;
}


/**
 * ノード要素からJSONを作成して返す。呼び出し元でpush必要。
 * @param {jQueryObject} nodeElement 対象ノードのjQueryオブジェクト
 * @return {JSON} ノード情報
 */
function getNodeData(nodeElement) {

	let nodeElementId = nodeElement.attr('id').replace('node-', '');

	// NodeのみlocalIndexの取得
	let localIndex = 0;
	if (nodeElement.hasClass('node')) {
		let parentSection = nodeElement.closest('.section');
		parentSection.find('>.nodes>.node').each(function (i, element) {
			if ($(element).attr('id') == nodeElement.attr('id')) {
				localIndex = i;
			}
		});
	}

	// contentTypeの取得。存在しない場合はtextとする
	let contentType = nodeElement.attr('data-content-type');
	if (contentType === undefined || contentType === null) {
		contentType = "text";
	}
	// 子が存在しないtextは、menu_flg=0扱い
	if (contentType == "text" && nodeElement.find('>.section>.nodes>.node').length == 0) {
		contentType = "answer";
	}

	// contentの取得。sectionの場合はtextarea, nodeの場合はinputから取得する
	let content = "";
	if ($(nodeElement).hasClass('section')) {
		content = $(nodeElement).find('>.content textarea').val();
	} else {
		content = $(nodeElement).find('>.node-label>input').val();
	}

	// parentIdの設定
	let parentId = 0;
	if (nodeElement.hasClass('first')) {
		// 最初のセクションの場合は親が存在しないので0を設定する
		parentId = 0;
	} else {
		// 自身がノードで、セクションに属している場合はセクションのIDを設定する
		parentId = nodeElement.closest('.section').first().attr('id').replace('section-', '');
	}


	// JSON整形。値ない場合はnullになる
	let nodeData = {
		id: nodeElementId,
		contentType: contentType,
		content: content,
		parentId: parentId,
		localIndex: localIndex,
	}
	return nodeData;
}

/**
 * セクション要素からJSONを作成して返す。呼び出し元でpush必要。
 *
 * @param {jQueryObject} sectionElement
 * @return {JSON} セクション情報
 */
function getSectionData(sectionElement){
	let sectionElementId = sectionElement.attr('id').replace('section-', '');
	let content = "";
	let contentType = sectionElement.attr('data-content-type');
	// 子が存在しないtextは、menu_flg=0扱い
	if (contentType == "text" && sectionElement.find('>.nodes>.node').length == 0) {
		contentType = "answer";
	}
	content = $('#section-' + sectionElementId).find('>.content>textarea').val();

	let sectionData = {
		id: sectionElementId,
		contentType: contentType,
		content: content,
		localIndex: null,
		nextSectionId: null,
	}
	return sectionData;
}


/**
 * ツリー情報を更新、取得する関数
 *
 * @returns {JSON} ツリー情報JSON
 */
function getTreeData() {
	updateTreeData();
	// JSONを整形して表示
	// $('#result').text(JSON.stringify(_treeData, null, ' '));
	// JSONを返す
	return JSON.stringify(_treeData);
}

// # ノード追加ボタンのクリックイベント
function setAddNodeButtonEvent() {
	$('.add-node').off().on('click', function () {
		let callerSectionId = $(this).closest('.section').first().attr('id');
		$(_addNodeModal).find('#addNodeContent').val('');
		$(_addNodeModal).find('#addSectionContent').val('');
		$(_addNodeModal).find('#selectSectionQuestion').prop('checked', true);
		modalShow();
		$('#addNodeFromModal').off().on('click', function () {
			addNode(callerSectionId);
		});
	});
}

// # リンク確認ボタンのクリックイベント
function checkLinkButtonEvent() {
	$('.check-link').off().on('click', function () {
		let link = $(this).parent().find('textarea').first().val();
		window.open(link, '_blank');
	});
}

// # sortableの設定
function setSortable(jQueryObject) {
	// jQueryObjectからJSのElementに変換が必要なのでeach
	jQueryObject.each(function (i, element) {
		try {
			Sortable.destroy(element);
		} catch (e) { }

		Sortable.create(element, {
			animation: 150,
			handle: '.sortable-handle',
			filter: '.add-node',
			draggable: '>.sortable-element',
			ghostClass: 'ui-state-highlight',
			onStart:  onStartEvent,  // 2-1, ドラッグ開始時
			onEnd:    onEndEvent,    // 2-2, ドラッグ終了時
			onChange: onChangeEvent, // 2-3, ドラッグ変化時
			onSort:   onSortEvent    // 2-4, 並び替え終了時
		});
	});
}
function onStartEvent(e){}
function onEndEvent(e){}
function onChangeEvent(e){}
function onSortEvent(e){
	// ソート後の並び順に応じてノードを並び替える
	let nodeList = $(e.target);
	let sortableIds = nodeList.find('a').map(function () { return $(this).attr('href').replace('#node-', ''); });
	let nodeWrapper = nodeList.siblings('.nodes');
	let nodes = nodeWrapper.children('.node');
	nodes.detach();
	sortableIds.each(function (i, id) {
		let node = nodes.filter('#node-' + id);
		nodeWrapper.append(node);
	});
	updateNodeListHeight(nodeList);
	getTreeData();
}

// ノードの追加
function addNode(callerSectionId) {
	// モーダルの内容を取得
	let addNodeContent = $('#addNodeContent').val();
	let contentType = $('input[name="selectSectionType"]:checked').val();
	let addSectionContent = $('#addSectionContent').val();
	let localIndex = $('#' + callerSectionId).find('.node-list').children().length;
	let callerElement = $('#addNodeFromModal');
	callerElement.css('pointer-events', 'none');

	// 空でも追加できるようにバリデーションは一旦コメントアウト
	// if (addNodeContent.trim() == "") {
	//     alert('選択肢のテキストを入力してください。');
	//     callerElement.css('pointer-events', 'auto');
	//     return;
	// }
	// if (addSectionContent.trim() == "") {
	//     alert('セクションのテキストを入力してください。');
	//     callerElement.css('pointer-events', 'auto');
	//     return;
	// }
	if (contentType == undefined || contentType == null) {
		alert('セクションのタイプを選択してください。');
		callerElement.css('pointer-events', 'auto');
		return;
	}

	// 新規chat_optionを作成してIDを取得する
	$.ajax({
		url: '/create_chat_option',
		type: 'POST',
		data: {
			chatId: $('#chat-id').val(),
			nodeContentType: "text",
			nodeContent: addNodeContent,
			sectionContentType: contentType,
			sectionContent: addSectionContent,
			parentId: callerSectionId.replace('section-', ''),
			localIndex: localIndex,
		}
	})
		.done(function (data) {
			if (data['result'] != "success") { alert('追加に失敗しました。'); callerElement.css('pointer-events', 'auto'); return; }

			// 追加処理続行
			// createNodeに渡すためのノード情報を作成
			let newNodeData = {
				id: data['nodeId'],
				contentType: contentType,
				content: addNodeContent,
				parentId: callerSectionId,
				localIndex: localIndex,
				nextSectionId: data['nodeId'],
			}

			let newSectionData = {
				id: data['nodeId'],
				contentType: contentType,
				content: addSectionContent,
				parentId: data['nodeId'],
				localIndex: null,
				nextSectionId: null,
			}

			// ノードを生成
			_treeData.nodes.push(newNodeData);
			_treeData.sections.push(newSectionData);
			createNode(newNodeData, callerSectionId.replace('section-', ''));

			// イベントの再設定
			setAddNodeButtonEvent();
			setNodeEvent();
			setSectionEvent();
			checkLinkButtonEvent();
			setSortable($('.sortable'));

			// 目次高さの調整
			updateNodeListHeight($(`#${callerSectionId}`).children('.node-list'));

			// 追加したノードまでスクロール
			scrollToTarget($('#node-' + data['nodeId']));


			// モーダルを閉じる
			modalHide();
		})
		.fail(function () {
			// 追加処理中断
			alert('500ERROR');
			$('#saving-flg').text('エラー');
		});
	callerElement.css('pointer-events', 'auto');
}


// ノードのイベント設定
// フォーカス時に削除ボタンを表示、ブラー時に削除ボタンを削除する
function setNodeEvent() {
	$('.node-label>input[type="text"]').off().on('focus', function () {
		let targetElement = $(this).closest('.node-label');
		// 削除ボタンの追加
		let deleteButton = $('<div id="remove-node"></div>');
		targetElement.append(deleteButton);
		// inputのblurより先に発火させるため、mousedownでイベントを設定する
		deleteButton.off().on('mousedown', function () {
			removeNode(targetElement.closest('.node').first().attr('id'));
		});
	});

	$('.node-label>input[type="text"]').on('blur', function () {
		$('#remove-node').remove();
	});

	$('.node-label>input[type="text"]').on('change', function () {
		// 対応するnode-list内のアンカーのテキストを変更する
		let parentSection = $(this).closest('.section').first();
		let targetNodeId = $(this).closest('.node').first().attr('id');
		let targetNodeAnchor = parentSection.find('.node-list a[href="#' + targetNodeId + '"]').first();
		targetNodeAnchor.text($(this).val());
		// 保存
		updateTreeData();
	});
}

// ノードの削除
function removeNode(targetNodeId) {
	let targetNode = $('#' + targetNodeId);
	// 目次から削除
	targetNode.parent().parent().find('.node-list a[href="#' + targetNodeId + '"]').parent().remove();
	// ノードを削除
	targetNode.remove();
	// セクションが空になったら、stickyクラスを削除
	if (targetNode.parent().children().length == 0) {
		targetNode.parent().removeClass('sticky');
	}
	updateNodeListHeight(targetNode.parent().parent().find('.node-list').first());
	updateTreeData();
}

// セクションのイベント設定
function setSectionEvent(sectionElement = null) {
	if (sectionElement === null) {
		sectionElement = $('.section');
	}
	sectionElement.find('textarea').off().on('change', function () {
		updateTreeData();
	});
}

//ブラウザバック時、セーブ前なら警告を出す
$(window).on('beforeunload', function (e) {
	if (_saveTreeTimer !== null || _savingFlg) {
		return 'このページを離れると、編集内容が失われます。';
	}
});

/**
 * 目次の高さを更新し、ノードの高さを調整する
 *
 * @param {jQueryObject} nodeListElement 目次のjQueryオブジェクト
 */
function updateNodeListHeight(nodeListElement) {
	let nodeHeight = nodeListElement.outerHeight(true);
	let nodes = nodeListElement.siblings('.nodes');
	nodes.find('> .node').each(function (i, element) {
			$(element).css('margin-bottom', nodeHeight);
	});

	// 高さが変動するので、canvasの高さを再計算する
	updateCanvasHeight();
}


/**
 *  canvasの高さを再計算する関数
 *
 *  overflow-x:scroll と sticky を共存させるために、縦軸でスクロールできる高さのheightを設定する必要あり.
 *
 *  ※ 現在は、高さを固定値にしているが、不具合が出たら、コメントアウトを外して動的に高さを設定する。
 */
function updateCanvasHeight() {
	let canvasElement = $('#' + _treeData.canvasElementId);
	let targetElement = canvasElement.find('.first').first();
	canvasElement.css('height', 500);
	// canvasElement.css('height', targetElement.outerHeight(true));
}


/**
 * ツリー情報を保存する関数
 *
 * 下記情報をupdate_chat_optionsへPOSTする
 * - chat_id
 * - nodes_hash (JSON) { firstSection: {最初の質問用データ}, nodes: [ {chat_option用データ}, {chat_option用データ}, ... ] }
 *
 * 保存完了後、最新の履歴として保持する。履歴から更新された場合は、履歴に追加しない
 *
 * @param {Boolean} whenHistory 履歴からの更新呼び出しかどうか
*/
function saveTreeData(whenHistory = false){
	savingFlg(true);
	let uploadData = {
		nodes: [],
	};

	// 最初の質問セクションを取得して格納
	let firstSection = $('#section-0').first();
	let firstSectionData = {
		id: 0,
		parent_id: null,
		content: firstSection.find('>.content>textarea').val(),
	}
	uploadData.firstSection = firstSectionData;

	_treeData.nodes.forEach(function (node, i) {
		// 対応するsectionが存在する場合は、contentを取得する
		let content = "";
		let contentType = "text";
		let section = _treeData.sections.find(section => section.id == node.id);
		if (section) {
			content = section.content;
			contentType = section.contentType;
		}

		let uploadNode = {
			id: node.id,
			parent_id: node.parentId,
			caption: node.content,
			content_type : contentType,
			content: content,
			localIndex: node.localIndex,
		}
		uploadData.nodes.push(uploadNode);
	});

	$.ajax({
		url: '/update_chat_options',
		type: 'POST',
		data: {
			"chat_id": $('#chat-id').val(),
			"nodes_hash": uploadData,
		}
	})
		.done(function (data) {
			// 失敗
			if (data['result'] != "success") { alert('保存に失敗しました。'); return; }

			// 成功
			// console.log('save success');
			// 通常更新なら、履歴に追加。履歴からの更新なら、履歴に追加しない
			if (whenHistory == false) {
					addHistory();
			}
		})
		.fail(function () {
			alert('500ERROR');
		});
	savingFlg(false);
}

// 保存中フラグの切り替え
function savingFlg(boolean) {
	_savingFlg = boolean;
	if ('#saving-flg') {
		if (_savingFlg) {
			$('#saving-flg').text('保存中...');
		}else{
			$('#saving-flg').text('保存済');
		}
	}
}


/**
 * アンカースクロール補助関数
 *
 * Stickyを用いている関係上、直接的なターゲット指定のスクロールをするとずれてしまうため、この関数を使用推奨します。
 * キャンバスのスクロール量とターゲットの相対位置を計算し、スクロールを実行します。
 *
 * @param {jQueryObject} targetjQueryElement スクロール位置の要素
 */
function scrollToTarget(targetjQueryElement) {
	let canvasElement = $('#' + _treeData.canvasElementId);
	let targetOffsetTop = targetjQueryElement.offset().top - canvasElement.offset().top;
	let canvasScrolledAmount = canvasElement.scrollTop();
	let newScrollTop = canvasScrolledAmount + targetOffsetTop;
	canvasElement.animate({ scrollTop: newScrollTop }, 'fast');
}

// ##############################
// ヒストリー系
// マックスは10
// _treeHistory = {index: 0, history: [ {_treeData}, {_treeData}, ... ]};
// undo, redoにあわせて indexをずらしていく
// saveが呼び出されたら、index!=maxなら、index以降のhistoryを削除して、新しいデータを追加する。indexは最後に。
// ##############################

// treeDataの更新時に、ヒストリーに追加する
// 最大保持数は10. 超過分は先頭から削除する
// indexの途中に追加された場合は、index以降のhistoryを削除して、新しいデータを追加する
function addHistory() {
	// 途中追加なら、index以降のhistoryを削除
	if (_treeHistory.index !== _treeHistory.history.length - 1) {
		_treeHistory.history = _treeHistory.history.slice(0, _treeHistory.index);
	}
	// ヒストリーに追加し、indexを更新。 _treeDataをそのまま追加するとオブジェクト参照されてしまうので、ディープコピーで複製する。
	_treeHistory.history.push(JSON.parse(JSON.stringify(_treeData)));
	_treeHistory.index = _treeHistory.history.length-1;
	// 最大保持数を超えたら、先頭から削除
	if (_treeHistory.history.length > _maxHistory) {
		_treeHistory.history.shift();
	}
	// undoボタンの無効化
	if ($('#tree-undo') && $('#tree-redo') && _treeHistory.history.length > 1) {
		$('#tree-undo').removeClass('disabled');
		$('#tree-redo').addClass('disabled');
	}
	// console.log(_treeHistory);
}

// 1つ前に戻す
function undoTree() {
	console.log('undo');
	if (_treeHistory.index > 0) {
		_treeHistory.index -= 1;
		_treeData = _treeHistory.history[_treeHistory.index];
		createTree(_treeData, true);
		updateTreeData(true);

		// undoボタンの無効化
		if ($('#tree-undo') && $('#tree-redo')) {
			if (_treeHistory.index == 0) {
				$('#tree-undo').addClass('disabled');
			}
			$('#tree-redo').removeClass('disabled');
		}
		// console.log(_treeHistory);
	}else{
		alert('これ以上戻れません。');
	}
}

// 1つ後に進める
function redoTree() {
	console.log('redo');
	if (_treeHistory.index < _treeHistory.history.length-1) {
		_treeHistory.index += 1;
		_treeData = _treeHistory.history[_treeHistory.index];
		createTree(_treeData, true);
		updateTreeData(true);

		// redoボタンの無効化
		if ( $('#tree-undo') && $('#tree-redo') ) {
				if (_treeHistory.index == _treeHistory.history.length-1) {
						$('#tree-redo').addClass('disabled');
				}
				$('#tree-undo').removeClass('disabled');
		}
		// console.log(_treeHistory);
	}else{
		alert('これ以上進めません。');
	}
}

// グローバルスコープに登録
window.createTree = createTree;
window.updateTreeData = updateTreeData;
